module.exports = __webpack_public_path__ + "static/media/trash-blue.7635392f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/trash-blue.svg
// module id = 265
// module chunks = 0